import axiosApi from "../axiosApi"


class DokumentService {
  getGrid() {
    return axiosApi.get("document/grid");
  }

  getDokument(dokumentId) {
    return axiosApi.get("document/document", {
      params: {
        id: dokumentId,
      }
    });
  }

  getComments(dokumentId) {
    return axiosApi.get("document/comments", {
      params: {
        id: dokumentId
      }
    })
  }

  
  getAttachments(dokumentId) {
    return axiosApi.get("document/attachments", {
      params: {
        id: dokumentId
      }
    })
  }

  
  getAttachment(id) {
    return axiosApi.get("document/attachment", {
      params: {
        id: id
      },
      responseType: 'arraybuffer'
    })
  }

  insertComment(dokumentId, comment) {
    return axiosApi.post("document/commentinsert", {
      dokumentId: dokumentId, 
      vsebina: comment, 
  })
  }

  updateDokumentApprove(dokumentId) {
    return axiosApi.post("document/approve", 
    {
        dokumentId: dokumentId
    })
  }

  updateDokumentDeny(dokumentId, comment) {
    return axiosApi.post("document/deny", 
    {
        dokumentId: dokumentId, 
        vsebina: comment
    })
  }

  updateDokumentForward(dokumentId, potrjevalciList, nivo) {
    return axiosApi.post("document/forward", {
        dokumentId: dokumentId, 
        potrjevalciList: potrjevalciList, 
        nivo: nivo
    })
  }

  updateDokumentComment(dokumentId, comment, uporabnikId) {
    return axiosApi.post("document/comment", {
        dokumentId: dokumentId, 
        vsebina: comment, 
        dodeljenUporabnikId: uporabnikId
    })
  }

  getNextDokument(dokumentId, dokumentTipId) {
      return axiosApi.get("document/getNextDocument", {
              params: {
                  dokumentId: dokumentId,
                  dokumentTipId: dokumentTipId
              }
          })
  }
}

export default new DokumentService();
